module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/chat-message-ecbf51124fc5e61255fc0277940a75fc.svg";